import React from 'react';

// third party 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//components
import Loading from '../component/loading';

//root
import Root from '../root';


const ReactToastifyMiddleware = () => {
    return (
        <>
            <Root />
            <ToastContainer />
            <Loading />
        </>

    )
}

export default ReactToastifyMiddleware